import ClickWebP from '@crazyegginc/hatch/dist/images/illustration-button.webp';
import ClickPNG from '@crazyegginc/hatch/dist/images/illustration-button.png';
import UrlVisitWebP from '@crazyegginc/hatch/dist/images/illustration-webpage-tick.webp';
import UrlVisitPNG from '@crazyegginc/hatch/dist/images/illustration-webpage-tick.png';
import FormSubmissionWebP from '@crazyegginc/hatch/dist/images/illustration-form.webp';
import FormSubmissionPNG from '@crazyegginc/hatch/dist/images/illustration-form.png';
import CodeWebP from '@crazyegginc/hatch/dist/images/illustration-javascript-page.webp';
import CodePNG from '@crazyegginc/hatch/dist/images/illustration-javascript-page.png';
import ApiWebP from '@crazyegginc/hatch/dist/images/illustration-api.webp';
import ApiPNG from '@crazyegginc/hatch/dist/images/illustration-api.png';
import GoalWebP from '@crazyegginc/hatch/dist/images/illustration-goal-target.webp';
import GoalPNG from '@crazyegginc/hatch/dist/images/illustration-goal-target.png';
import PixelWebP from '@crazyegginc/hatch/dist/images/illustration-pixel.webp';
import PixelPNG from '@crazyegginc/hatch/dist/images/illustration-pixel.png';
import EcommerceWebP from '@crazyegginc/hatch/dist/images/illustration-ecommerce.webp';
import EcommercePNG from '@crazyegginc/hatch/dist/images/illustration-ecommerce.png';

// export const PER_PAGE_OPTIONS = [25, 50, 100, 200];
export const PER_PAGE_OPTIONS = [5, 10, 25, 50];

export const MAXIMUM_SELECTION = 5;

export const GOAL_TRIGGER_TYPES = {
  CLICK: 'CLICK',
  URL_VISIT: 'URL_VISIT',
  FORM_SUBMISSION: 'FORM_SUBMISSION',
  PIXEL_EVENT: 'PIXEL_EVENT',
  ECOMMERCE_EVENT: 'ECOMMERCE_EVENT',
  CODE: 'CODE',
  API: 'API',
};

// trigger types that are available in the wizard
export const SELECTABLE_GOAL_TRIGGER_TYPES = {
  CLICK: 'CLICK',
  URL_VISIT: 'URL_VISIT',
  FORM_SUBMISSION: 'FORM_SUBMISSION',
  PIXEL_EVENT: 'PIXEL_EVENT',
  ECOMMERCE_EVENT: 'ECOMMERCE_EVENT',
  CODE: 'CODE',
};

export const GOAL_TRIGGERS_METADATA = {
  [GOAL_TRIGGER_TYPES.CLICK]: {
    webp: ClickWebP,
    png: ClickPNG,
    description: (
      <span>
        <strong>Clicks an element</strong> on
      </span>
    ),
    label: (
      <span className="text-xs font-normal">
        When someone <strong className="font-semibold">clicks on a button or link</strong>
      </span>
    ),
    selectLabel: 'Clicks on a button or link',
  },
  [GOAL_TRIGGER_TYPES.URL_VISIT]: {
    webp: UrlVisitWebP,
    png: UrlVisitPNG,
    description: <strong>Visits</strong>,
    label: (
      <span className="text-xs font-normal">
        When someone <strong className="font-semibold">reaches a certain page</strong>
      </span>
    ),
    selectLabel: 'Reaches a certain page',
  },
  [GOAL_TRIGGER_TYPES.FORM_SUBMISSION]: {
    webp: FormSubmissionWebP,
    png: FormSubmissionPNG,
    description: (
      <span>
        <strong>Submits a form</strong> on
      </span>
    ),
    label: (
      <span className="text-xs font-normal">
        When someone
        <br />
        <strong className="font-semibold">fills out a form</strong>
      </span>
    ),
    selectLabel: 'Fills out a form',
  },
  [GOAL_TRIGGER_TYPES.PIXEL_EVENT]: {
    webp: PixelWebP,
    png: PixelPNG,
    description: (
      <span>
        <strong>Triggers a pixel conversion</strong> on
      </span>
    ),
    label: (
      <span className="text-xs font-normal">
        When someone <strong className="font-semibold">triggers an ad</strong>
        <br />
        <strong className="font-semibold">conversion pixel</strong>
      </span>
    ),
    selectLabel: 'Triggers an ad conversion pixel',
  },
  [GOAL_TRIGGER_TYPES.ECOMMERCE_EVENT]: {
    webp: EcommerceWebP,
    png: EcommercePNG,
    description: (
      <span>
        <strong>completes</strong> an
      </span>
    ),
    label: (
      <span className="text-xs font-normal leading-none">
        When someone completes an
        <br />
        <strong className="font-semibold">eCommerce event</strong>
      </span>
    ),
    selectLabel: 'Completes an eCommerce event',
  },
  [GOAL_TRIGGER_TYPES.CODE]: {
    webp: CodeWebP,
    png: CodePNG,
    description: (
      <span>
        <strong>Triggers a script</strong> on
      </span>
    ),
    label: (
      <span className="text-xs font-normal">
        When someone <strong className="font-semibold">triggers a script</strong>
        <br />
        <span className="text-lynch-500">(advanced)</span>
      </span>
    ),
    selectLabel: 'Triggers a script',
  },
  [GOAL_TRIGGER_TYPES.API]: {
    webp: ApiWebP,
    png: ApiPNG,
    description: (
      <span>
        <strong>Called via API</strong>
      </span>
    ),
    label: (
      <span className="text-xs font-normal">
        When it gets <strong className="font-semibold">called via API</strong>
        <br />
        <span className="text-lynch-500">(advanced)</span>
      </span>
    ),
    selectLabel: 'Called via API',
    info: 'This trigger was added automatically when you called our API. You can not edit it. To delete it (1) stop sending us this event via our API, and then (2) delete the Goal.',
  },
  OTHER: {
    webp: GoalWebP,
    png: GoalPNG,
    selectLabel: 'Custom trigger',
  },
};

export const PIXEL_API_LIST = {
  TIKTOK: 'tiktok',
  META: 'meta',
  GOOGLE: 'google',
};

export const ECOMMERCE_LIST = {
  SHOPIFY: 'shopify',
  MAGENTO: 'magento',
  WOOCOMMERCE: 'woocommerce',
  WIXAPI: 'wixapi',
  SQUARESPACE: 'squarespace',
  GENERIC: 'generic',
};

export const ANY_PIXEL_ID = 'ANY_PIXEL_ID';
export const ENTER_YOUR_OWN_EVENT = 'Enter your own...';

export const GOOGLE_PIXEL_EVENTS = [
  { value: 'conversion', label: 'Conversion' },
  { value: 'ad_click', label: 'Ad Click' },
  { value: 'page_view', label: 'Page View' },
  { value: 'video_progress', label: 'Video Progress' },
  { value: 'scroll', label: 'Scroll' },
  { value: 'click', label: 'Click' },
  { value: 'file_download', label: 'File Download' },
];

export const ECOMMERCE_EVENTS_LIST_TYPE = {
  ADD_TO_CART: 'addToCart',
  START_CHECKOUT: 'startCheckout',
  COMPLETE_CHECKOUT: 'checkoutCompleted',
};

export const ECOMMERCE_EVENTS_LIST = {
  SHOPIFY: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout', disabled: true },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.COMPLETE_CHECKOUT, label: 'Complete Checkout', disabled: true },
  ],
  MAGENTO: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.COMPLETE_CHECKOUT, label: 'Complete Checkout' },
  ],
  WOOCOMMERCE: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.COMPLETE_CHECKOUT, label: 'Complete Checkout' },
  ],
  WIXAPI: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.COMPLETE_CHECKOUT, label: 'Complete Checkout' },
  ],
  SQUARESPACE: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout' },
  ],
  GENERIC: [
    { value: ECOMMERCE_EVENTS_LIST_TYPE.ADD_TO_CART, label: 'Add to Cart' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.START_CHECKOUT, label: 'Start Checkout' },
    { value: ECOMMERCE_EVENTS_LIST_TYPE.COMPLETE_CHECKOUT, label: 'Complete Checkout' },
  ],
};

export const GOAL_PURPOSES = {
  MORE_PAGE_VIEWS: 'MORE_PAGE_VIEWS',
  MORE_REGISTRATIONS: 'MORE_REGISTRATIONS',
  SELL_MORE: 'SELL_MORE',
  OTHER: 'OTHER',
};

export const ELEMENT_SELECTOR_TYPES = {
  SPECIFIC: 'SPECIFIC',
  BROAD: 'BROAD',
  MANUAL: 'MANUAL',
};

export const GOAL_TRACKING_OPTIONS = {
  SPECIFIC_PAGE: 'SPECIFIC_PAGE',
  ANY_PAGE: 'ANY_PAGE',
  WILDCARD: 'WILDCARD',
};

export const GOAL_UI_MODES = {
  SIMPLE: 'SIMPLE',
  ADVANCED: 'ADVANCED',
};

export const GOALS_DASHBOARD_PATH = '/goals';

export const GOAL_VALUE_TYPES = {
  FIXED: 'FIXED',
  ELEMENT: 'ELEMENT',
  CODE: 'CODE',
};

export const TRIGGER_CHART_TYPES = {
  SEPARATE: 'SEPARATE',
  COMBINE: 'COMBINE',
};

export const COLOR_MATRIX = [
  { tw: 'bg-[#4ba2f8]', hex: '#4ba2f8' },
  { tw: 'bg-lavender-500', hex: '#ba89f5' },
  { tw: 'bg-lima-500', hex: '#8abc00' },
  { tw: 'bg-pink-salmon-500', hex: '#ff8fa7' },
  { tw: 'bg-dandelion-500', hex: '#ffd155' },
  { tw: 'bg-dodger-blue-500', hex: '#0086e6' },
  { tw: 'bg-wisteria-500', hex: '#8a3de0' },
  { tw: 'bg-[#65e3dd]', hex: '#65e3dd' },
  { tw: 'bg-[#ef9906]', hex: '#ef9906' },
  { tw: 'bg-[#ff7679]', hex: '#ff7679' },
];
